import { Grid, Typography } from "@mui/material";
import { getMetaTagsRequest, updateMetaTagsRequest } from "api/metaTags";
import DrawerCM from "components/shared/Drawer";
import LoadingCM from "components/shared/Loading";
import StackCm from "components/shared/StackCm";
import TextFieldCm from "components/shared/TextField";
import Toast from "helper/toast";
import useHttp from "hooks/use-http";
import React, { Fragment, useCallback, useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { StyledGlBtn, StyledGlTitle } from "styles/globals";

const INPUTS = [
  {
    id: "slug",
    label: "صفحه",
    type: "select",
    gridOption: {
      md: 4,
    },
    selectItems: [
      {
        value: "home",
        title: "صفحه اصلی",
      },
      {
        value: "blog",
        title: "وبلاگ",
      },
      {
        value: "adv",
        title: "آگهی ها",
      },
      {
        value: "aboutUs",
        title: "درباره ما",
      },
      {
        value: "contactUs",
        title: "ارتباط با ما",
      },
      {
        value: "advice",
        title: "مشاوره",
      },
      {
        value: "search",
        title: "جست و جو",
      },
    ],
  },
  {
    id: "keyword",
    label: "کلمات کلیدی",
    gridOption: {
      md: 8,
    },
  },
  {
    id: "description",
    label: "توضیحات",
    gridOption: {
      md: 12,
    },
    rows: 2,
  },
];

export default function MetaTags() {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors },
  } = useForm();

  const { request, loading } = useHttp(false);

  const [data, setData] = useState();

  const onSubmit = async (data) => {
    const res = await request({
      url: updateMetaTagsRequest,
      values: data,
    });
    if (res) {
      Toast({ type: "success" });
      getMetaData();
    }
  };

  const getMetaData = useCallback(async () => {
    const res = await request({
      url: getMetaTagsRequest,
    });
    setData(res);
  }, []);

  useEffect(() => {
    getMetaData();
  }, []);

  useEffect(() => {
    if (data) {
      watch("slug") && setValue("keyword", data[watch("slug")].keyword);
      watch("slug") && setValue("description", data[watch("slug")].description);
    }
  }, [data, watch("slug")]);

  return (
    <DrawerCM title="متا تگ ها">
      {loading ? (
        <LoadingCM />
      ) : (
        <>
          <StackCm title="فیلدهای متا تگ ها">
            <Grid container>
              {INPUTS.map((input) => (
                <Grid
                  key={input.id}
                  item
                  md={input.gridOption.md}
                  xs={12}
                  p={1.5}
                >
                  <TextFieldCm
                    {...input}
                    register={register}
                    control={control}
                    errors={errors}
                    shrink={Boolean(watch(input.id))}
                  />
                </Grid>
              ))}
              <StyledGlBtn onClick={handleSubmit(onSubmit)} />
            </Grid>
          </StackCm>
          <StackCm title={"مقادیر فعلی"}>
            {data &&
              INPUTS[0].selectItems.map(
                (item) => (
                  <Fragment key={item.value}>
                    <StyledGlTitle color="primary">
                      {item.title}
                      <Typography
                        color={"gray"}
                        component={"div"}
                        fontSize={"16px"}
                      >
                        {"کلمات کلیدی:"}
                        <p>{data[item.value].keyword ?? ""}</p>
                      </Typography>
                      <Typography
                        color={"gray"}
                        component={"div"}
                        fontSize={"16px"}
                      >
                        {"توضیحات:"}
                        <p>{data[item.value].description ?? ""}</p>
                      </Typography>
                    </StyledGlTitle>
                  </Fragment>
                ),
                []
              )}
          </StackCm>
        </>
      )}
    </DrawerCM>
  );
}
